import { render, staticRenderFns } from "./leftNavDefault.vue?vue&type=template&id=db5da630&scoped=true&"
import script from "./leftNavDefault.vue?vue&type=script&lang=js&"
export * from "./leftNavDefault.vue?vue&type=script&lang=js&"
import style0 from "./leftNavDefault.vue?vue&type=style&index=0&id=db5da630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5da630",
  null
  
)

export default component.exports